module.exports = __webpack_public_path__ + "img/celiang.be0dafdd.png";